import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export function PartnerRoute() {
  const { isBootstrapping, isAuthenticated, hasPendingVerification, hasPendingWorkspaceSelection, hasPartnerAccess } = useAuth();

  if (isBootstrapping) {
    return null;
  }

  if (!isAuthenticated) {
    if (hasPendingVerification) {
      return <Navigate to="/verify-email" replace />;
    }

    if (hasPendingWorkspaceSelection) {
      return <Navigate to="/select-workspace" replace />;
    }

    return <Navigate to="/login" replace />;
  }

  if (!hasPartnerAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
